<h1 mat-dialog-title class="text-center mb-0 fw-bold">Connect child</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <!-- TABLE -->
    <div *ngIf="!shouldRenderConditionComponent" class="mat-elevation-z2" [hidden]="isLoading">
        <div class="d-flex justify-content-around p-2 mb-4">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Filter By name</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Collect name" #input>
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row" class="fw-bold"> {{row.name}} </td>
            </ng-container>
            
            <ng-container matColumnDef="Directive">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Directive</th>
                <td mat-cell *matCellDef="let row" class="text-left"> {{row.directive.slice(0, 60)}}... </td>
            </ng-container>

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" (click)="onConnectClicked(row)">Connect</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>
    </div>

    <!-- CONDITION INPUT -->
    <div *ngIf="shouldRenderConditionComponent" class="h-100 d-flex align-items-center justify-content-center">
        <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Condition</mat-label>
            <mat-error *ngIf="conditionFormControl.hasError('required')">Value cannot be empty</mat-error>
            <mat-error *ngIf="conditionFormControl.hasError('minlength')">Value must be over 3 characters</mat-error>
            <input matInput placeholder="Ex: if user says no" [formControl]="conditionFormControl" required>
            <mat-hint>Enter the condition to connect</mat-hint>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex justify-content-around mt-1">
    <button [disabled]="isLoading" mat-raised-button color="warn" class="w-25" (click)="onBackCancelClicked()">{{shouldRenderConditionComponent ? 'Back' : 'Cancel'}}</button>
    <button *ngIf="shouldRenderConditionComponent" [disabled]="isLoading || !conditionFormControl.valid" mat-raised-button color="primary" class="w-25" (click)="onAddArc()">
        <span *ngIf="!isLoading">Connect</span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
            class="mx-auto mat-spinner"></mat-spinner>
        </button>
</mat-dialog-actions>